import React from 'react'
import { Link } from 'react-router-dom'
import BG from '../../../assets/images/services/services-s-cta-1-1.jpg'
import { useTranslation } from 'react-i18next';

const ServiceSidebar = () => {
  const { t } = useTranslation();
  return (
    <div className="sidebar">
      <div className="sidebar__item sidebar__item--category">
        <h3 className="sidebar__title">{t('industries.common.sidebar_categories')}</h3>
        <ul className="sidebar__category">
          <li>
            <li>
              <Link to="/Webapp">{t('industries.common.sidebar_web_app')}</Link>
            </li>
            <li>
              <Link to="/mobileapp">{t('industries.common.sidebar_mobile_app')}</Link>
            </li>
            <li>
              <Link to="/frontend">{t('industries.common.sidebar_frontend')}</Link>
            </li>
            <li>
              <Link to="/Clouddev">{t('industries.common.sidebar_cloud_devops')}</Link>
            </li>
            <li>
              <Link to="/Chatbot">{t('industries.common.sidebar_chatbot')}</Link>
            </li>
            <li>
              <Link to="/Bigdata">{t('industries.common.sidebar_bigdata')}</Link>
            </li>
            <li>
              <Link to="/qa-testing">{t('industries.common.sidebar_qa')}</Link>
            </li>
            <li>
              <Link to="/Cloudintegration">{t('industries.common.sidebar_cloud_integration')}</Link>
            </li>
            <li>
              <Link to="/ITmerit">{t('industries.common.sidebar_it_metrics')}</Link>
            </li>
            <li>
              <Link to="/cyber-security">{t('industries.common.sidebar_cyber_security')}</Link>
            </li>
          </li>
        </ul>
      </div>
      <div className="sidebar__item sidebar__item--cta">
        <div className="sidebar__cta"
          style={{ backgroundImage: `url(${BG})` }}>
          <i className="sidebar__cta__icon fa fa-envelope"></i>
          <h3 className="sidebar__cta__title">{t('industries.common.tech_problems')}</h3>
          <p className="sidebar__cta__text">{t('industries.common.call_anytime')} <br /><Link to="mailto:info@codecraftcorp.org">{t('industries.common.call_num')}</Link></p>

        </div>
      </div>
      <div className="sidebar__item sidebar__item--btn none">
        <Link to="#" className="thm-btn sidebar__btn"><span>{t('industries.common.download')}</span></Link>
      </div>
    </div>
  )
}

export default ServiceSidebar